import React from 'react';
import { useUserCity } from '../hooks/useUserCity';
export function Hero() {
  const {
    city,
    loading
  } = useUserCity('Local');
  return <div className="mb-8" data-id="element-74">
      {loading ? <div className="animate-pulse space-y-3" data-id="element-75">
          <div className="h-10 bg-gray-200 rounded-lg w-full" data-id="element-76" />
          <div className="h-10 bg-gray-200 rounded-lg w-5/6" data-id="element-77" />
          <div className="h-8 bg-gray-100 rounded-lg w-3/4" data-id="element-78" />
        </div> : <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6 font-sans" style={{
      animation: 'fadeIn 0.4s ease-in'
    }} data-id="element-79">
          <span className="bg-[#FEF3C7] px-1" data-id="element-80">{city} Doctors Reveal</span> Why
          Your Nightly Wine Stopped Relaxing You{' '}
          <span className="text-gray-600 font-normal italic text-2xl md:text-3xl lg:text-4xl" data-id="element-81">
            (And Started Making You MORE Stressed)
          </span>
        </h1>}

      <style data-id="element-82">{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>;
}